import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

// Icon per entity kind; anything unmapped gets a neutral one, so new kinds
// added on the agent side render without an FE change.
const KIND_ICONS = {
  seller_profile: "badge",
  inbox: "mail",
  account_list: "domain",
  contact_list: "group"
};

/**
 * List-shaped tool results, in one of two layouts.
 *
 * CARDS for a handful of rich records — each one is worth its own tile.
 * LIST once there are enough that the question becomes "which one", where a
 * grid of tiles is slower to scan than rows and pushes the answer off screen.
 * The agent picks (see entities.ts); both open the same detail panel on click,
 * so the layout changes the density, never the behaviour.
 */
const EntityCardsBlock = observer(({ block }) => {
  const items = block.items || [];
  if (!items.length) return null;
  const isList = block.layout === "list";
  const icon = KIND_ICONS[block.kind] || "web_stories";
  const activeId =
    copilotStore.entityPanel.open &&
    copilotStore.entityPanel.blockId === block.id
      ? copilotStore.entityPanel.itemId
      : null;

  return (
    <div className="copilotEntityCards">
      <div className="copilotEntityCards__title">
        <i className="material-icons-outlined">{icon}</i>
        <span>{block.title}</span>
        <span className="copilotEntityCards__count">{items.length}</span>
      </div>
      <div
        className={
          isList ? "copilotEntityCards__list" : "copilotEntityCards__grid"
        }
      >
        {items.map(item => (
          <button
            type="button"
            key={item.id}
            className={`${isList ? "copilotEntityRow" : "copilotEntityCard"} ${
              activeId === item.id ? "active" : ""
            }`}
            onClick={() => copilotStore.openEntityPanel(block.id, item.id)}
          >
            <div className="copilotEntityCard__top">
              <span className="copilotEntityCard__title">{item.title}</span>
              <i className="material-icons-outlined copilotEntityCard__open">
                chevron_right
              </i>
            </div>
            {item.subtitle && (
              <div className="copilotEntityCard__subtitle">{item.subtitle}</div>
            )}
            {(item.badges || []).length > 0 && (
              <div className="copilotEntityCard__badges">
                {item.badges.map(badge => (
                  <span
                    key={badge}
                    className={`copilotEntityCard__badge${
                      /^(active|connected|enabled|verified|yes|warming enabled)$/i.test(
                        badge
                      )
                        ? " is-positive"
                        : ""
                    }`}
                  >
                    {badge}
                  </span>
                ))}
              </div>
            )}
            {(item.fields || []).length > 0 && (
              <div className="copilotEntityCard__fields">
                {item.fields.slice(0, isList ? 1 : 2).map(field => (
                  <div key={field.label} className="copilotEntityCard__field">
                    <span className="copilotEntityCard__fieldLabel">
                      {field.label}
                    </span>
                    <span className="copilotEntityCard__fieldValue">
                      {field.value}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
});

export default EntityCardsBlock;
